var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"mediaFile","centered":"","size":"xl","ok-only":"","ok-variant":"outline-secondary","ok-title":"Закрыть","no-close-on-backdrop":"","title":_vm.mediaValue}},[_c('pdfTron',{attrs:{"initial-doc":_vm.mediaValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }